// extracted by mini-css-extract-plugin
module.exports = {"supportInfo":"SupportInfo_supportInfo__vHJXY","buttonsContainer":"SupportInfo_buttonsContainer__xzPQ1"};